<script lang="ts" setup>
import type { PageContent } from '~/app/features/cms/types/PageContent';
import { defaultTemplateComponent, schemaTypesToComponents } from '~/config/sanity/config';

const props = defineProps<{
  content?: PageContent | null
}>();

function typeToTemplate(schemaType?: string) {
  if (!schemaType || !(schemaType in schemaTypesToComponents)) {
    return defaultTemplateComponent ?? null;
  }

  return schemaTypesToComponents[schemaType];
}
</script>

<template>
  <component
    :is="typeToTemplate(props.content?._type)"
    :content="props.content"
  />
</template>

<style scoped>

</style>
